inputs-hidden
  input(if="{ opts.disable }" name="{ opts.name }" type="hidden" value="{ opts.value }" disabled="disabled")
  input(if="{ !opts.disable }" name="{ opts.name }" type="hidden" value="{ opts.value }")
  script(type="typescript").
    this.mixin('inputs.hidden');
